// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Nwssn","title":"Info_title__3Duby","links":"Info_links__v6HBI","link":"Info_link__BWtJY","logo":"Info_logo__2Q8mg"};